import { useCallback, useMemo } from 'react';

import { Row, Col, FormGroup, Label } from 'twyne-new.ui';

import InfoTip from 'components/InfoTip';
import Select from 'components/form/Select';
import { PureSwitch } from 'components/form/Switch';
import Rules from 'components/rules/Rules';

export default function CustomConversion({ value, onChange }) {
  const config = useMemo(() => value || {}, [value])

  const enabled = config.enabled === true
  const rules = useMemo(() => config.rules || { condition: 'and', groups: [{ condition: 'and', rules: [{}] }] }, [config.rules])
  const triggers = useMemo(() => Array.isArray(config.triggers) ? config.triggers : [], [config.triggers])

  const selectedTriggers = useMemo(() => TRIGGER_OPTIONS.filter(({ value }) => triggers.includes(value)), [triggers])

  const handleUpdate = useCallback(change => {
    const update = { ...config, enabled: true, ...change }
    onChange(update)
  }, [config, onChange])

  const handleToggle = event => {
    if (!event.target.checked) {
      onChange(null)
      return
    }
    handleUpdate({ triggers, rules })
  }

  const handleChangeTriggers = options => {
    handleUpdate({ triggers: Array.isArray(options) ? options.map(({ value }) => value) : [] })
  }

  return <Row>
    <Col size='2'>
      <FormGroup>
        <Label className='flex items-center gap-1'>
          Enable Custom Conversion
          <InfoTip id='custom-conversion' color='neutral' disabled>
            While enabled the lead holds at <strong>awaiting</strong> when the conversion step is reached, and only converts when a later event satisfies the rules below. No scrub and no pixel run until then. While disabled the lead converts as soon as the conversion step is reached.
          </InfoTip>
        </Label>
        <PureSwitch value={enabled} onChange={handleToggle} />
      </FormGroup>
    </Col>
    <Col size='4'>
      <FormGroup>
        <Label className='flex items-center gap-1'>
          Triggers
          <InfoTip id='custom-conversion-triggers' color='neutral' disabled>
            At least one event must be selected.
          </InfoTip>
        </Label>
        <Select
          multi
          name='_'
          required={enabled}
          validations={enabled ? { isRequired: (_, value) => Boolean(value?.length) } : {}}
          clearable={false}
          disabled={!enabled}
          options={TRIGGER_OPTIONS}
          value={selectedTriggers}
          handleOnChange={handleChangeTriggers}
        />
      </FormGroup>
    </Col>
    {enabled ? <Col size='12'>
      <Rules
        origin='custom-conversion'
        rules={rules}
        extraFields={EXTRA_RULES}
        handleChange={({ rules }) => handleUpdate({ rules })}
      />
    </Col> : null}
  </Row>
}

const TRIGGER_OPTIONS = [
  { label: 'Registration Completed', value: 'registration-completed' },
  { label: 'Incoming Revenue', value: 'incoming-revenue' },
  { label: 'Rewards Activity', value: 'rewards-activity' },
]

const EXTRA_RULES = [
  { value: 'trigger', label: 'Trigger', type: 'input', group: 'Traffic', options: TRIGGER_OPTIONS },
  { value: 'reward_points', label: 'Reward Points', type: 'integer', group: 'Rewards' },
  { value: 'reward_completed', label: 'Has Reward Completed', type: 'boolean', group: 'Rewards' },
  { value: 'reward_activities_count', label: 'Reward Activities Count', type: 'integer', group: 'Rewards' },
  { value: 'reward_completed_count', label: 'Reward Completed Activities Count', type: 'integer', group: 'Rewards' },
  { value: 'reward_payout', label: 'Reward Payout', type: 'float', group: 'Rewards' },
]
